import React from "react";
import { useRecoilState } from "recoil";
import { imageLightboxAtom } from "../../contexts/imageLightbox.recoil";
import ImageLightbox from "./ImageLightbox";

const TopImageLightbox: React.FC = () => {
	const [lightbox, setLightbox] = useRecoilState(imageLightboxAtom);

	if (!lightbox) {
		return null;
	}

	return (
		<ImageLightbox
			src={lightbox.src}
			alt={lightbox.alt ?? ""}
			originRect={lightbox.originRect}
			onClose={() => setLightbox(undefined)}
		/>
	);
};

export default TopImageLightbox;
